import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Global error handlers for debugging
window.addEventListener('unhandledrejection', (event) => {
  console.error('[UNHANDLED PROMISE REJECTION]', event.reason);
  console.error('[UNHANDLED PROMISE REJECTION] Stack:', event.reason?.stack);
  // Prevent default browser behavior
  event.preventDefault();
});

window.addEventListener('error', (event) => {
  console.error('[GLOBAL ERROR]', event.error);
  console.error('[GLOBAL ERROR] Message:', event.message);
  console.error('[GLOBAL ERROR] Filename:', event.filename);
  console.error('[GLOBAL ERROR] Line:', event.lineno);
  console.error('[GLOBAL ERROR] Column:', event.colno);
});

// Log React errors
const originalConsoleError = console.error;
console.error = (...args) => {
  originalConsoleError.apply(console, args);
  // Check if it's a React error
  if (args[0]?.includes?.('Error:') || args[0]?.includes?.('Warning:')) {
    console.error('[REACT ERROR DETECTED]', args);
  }
};

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);